const STORAGE_PREFIX = 'hijack_debug_console:player:';
const fallbackPreferences = new Map<string, boolean>();

export const DEBUG_CONSOLE_TOGGLE_EVENT = 'debug-console-toggle';

const storageKey = (playerGUID: string): string => `${STORAGE_PREFIX}${playerGUID}`;

export const isDebugConsoleEnabled = (playerGUID: string): boolean => {
  if (!playerGUID) return false;
  try {
    return window.localStorage.getItem(storageKey(playerGUID)) === '1';
  } catch {
    return fallbackPreferences.get(playerGUID) ?? false;
  }
};

export const setDebugConsoleEnabled = (playerGUID: string, enabled: boolean): void => {
  if (!playerGUID) return;
  fallbackPreferences.set(playerGUID, enabled);
  try {
    window.localStorage.setItem(storageKey(playerGUID), enabled ? '1' : '0');
  } catch {
    // The in-memory preference remains consistent for this session.
  }
  window.dispatchEvent(new Event(DEBUG_CONSOLE_TOGGLE_EVENT));
};
